import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "category"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  class: "graph-slot"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_hashed_number_value = _resolveComponent("hashed-number-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_column = _resolveComponent("flex-column");
  const _component_simple_area_chart = _resolveComponent("simple-area-chart");
  const _component_hug_value = _resolveComponent("hug-value");
  return _openBlock(), _createBlock(_component_hug_value, {
    class: "bsr-value-with-graph",
    loading: $props.loading,
    tight: ""
  }, {
    default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, null, [$props.activated ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createVNode(_component_flex_column, {
      class: "value-wrapper",
      gap: 4
    }, {
      default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
        gap: 16
      }, {
        evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
          value: Math.round($props.evolution)
        }, {
          default: _withCtx(({
            color
          }) => [_createVNode(_component_number_value, {
            value: $props.evolution,
            color: color,
            "show-sign": "",
            charCount: $props.evolCharCount,
            tight: ""
          }, null, 8, ["value", "color", "charCount"])]),
          _: 1
        }, 8, ["value"])]),
        default: _withCtx(() => [_createVNode(_component_hashed_number_value, {
          value: $props.value,
          prepend: "# "
        }, null, 8, ["value"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("a", {
        href: $props.categoryLink,
        target: "_blank"
      }, [_createVNode(_component_wrap_with_popover, {
        customClass: "bsr-category-popover",
        width: "fit-content",
        placement: "left"
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString($props.category), 1)]),
        default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($props.category), 1)]),
        _: 1
      })], 8, _hoisted_2)])]),
      _: 1
    }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_simple_area_chart, {
      data: $props.sparkline,
      width: 60,
      height: 41,
      min: $props.min,
      max: $props.max,
      popoverPosition: $props.last_item && !$props.single ? 'top-right' : 'bottom-right',
      highlightRange: $props.highlightRange
    }, null, 8, ["data", "min", "max", "popoverPosition", "highlightRange"])])], 64)) : _createCommentVNode("", true)], 1024))]),
    _: 1
  }, 8, ["loading"]);
}